import { Button, Typography } from '@breetometer/components';
import { CurrencyBalance, WalletIcon } from 'BreetAssets';

const DialogCryptoSettings = () => (
	<div className='dialog-crypto-settings bg-primary-500'>
		<WalletIcon variant='crypto-settings' />
		<Typography as='h5'>Change Your Default Settlement Wallet</Typography>

		<Typography>To continue, please change your Naira Wallet as your default settlement wallet in crypto settings.</Typography>

		<div className='currency-balance'>
			<CurrencyBalance
				variant='NGN'
				balance='1000'
			/>

			<CurrencyBalance
				variant='GHS'
				balance='1000'
			/>

			<CurrencyBalance
				variant='USD'
				balance='1000'
			/>
		</div>

		<div className='currency-balance-cta'>
			<Button>Save Changes</Button>
		</div>
	</div>
);

export default DialogCryptoSettings;
